module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zEX4nG/tc-custom/9781460322819.jpg?1728259357491",
      "alt": "This image is the cover for the book Maverick's Christmas Baby, Montana Mavericks: Rust Creek Cowboys"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Maverick's Christmas Baby, Montana Mavericks: Rust Creek Cowboys\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From a "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author, a blizzard brings together a pregnant woman and a single father, who fall in love despite their rival families.")]), _c('br'), _c('br'), _vm._v("RUST CREEK RAMBLINGS "), _c('br'), _c('br'), _vm._v("Rejoice, ye merry Mavericks! As Christmas approaches, we here at The Rust Creek Falls Rambler thought we’d reward our devoted followers with a blind item guaranteed to put a little extra jingle in your stockings. Which rugged Rust Creek Traub has been spotted canoodling with a very pregnant lady of the Crawford kind? "), _c('br'), _c('br'), _vm._v("Astute readers will guess we’re talking about divorced rancher Dallas Traub, who rescued expectant shopkeeper Nina Crawford from a snowy car wreck a few weeks back. Can these holiday honeys survive feuding families, three boisterous boys and a little bundle of joy intent on an early arrival? Only Santa knows for sure . . . and he might just be bringing the gift of love down the chimney this year!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Victoria Pade\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Victoria Pade is a USA Today bestselling author of multiple romance novels.  She has two daughters and is a native of Colorado, where she lives and writes.  A devoted chocolate-lover, she's in search of the perfect chocolate chip cookie recipe.  Readers can find information about her latest and upcoming releases by logging on to "), _c('a', {
    attrs: {
      "href": "http://www.vikkipade.com"
    }
  }, [_vm._v("www.vikkipade.com")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0